"use strict";

// DOM読み込み完了
document.addEventListener('DOMContentLoaded',  (event) => {
  console.log('DOM Content Loaded.');
  /* 処理内容を記述 */

  // var btnToggle = document.getElementsByClassName('toggle-submenu');
  // for (let i = 0; i < btnToggle.length; i++) {
  //   btnToggle[i].addEventListener('click', function() {
  //     btnToggle[i].classList.toggle('is-close');
  //     btnToggle[i].classList.toggle('is-open');
  //   }, false);
  // }

  // var state = false;
  // var scrollpos;
  // var drawerIcon = document.getElementById('drawer-icon');
  // var drawerBackground = document.getElementById('drawer-background');
  // var body = document.querySelectorAll('body')[0];

  // function scrollStop() {
  //   if(state == false) {
  //     scrollpos = window.scrollY;
  //     body.classList.add('js-fixed');
  //     body.style.top = -scrollpos + 'px';
  //     state = true;
  //   } else {
  //     body.classList.remove('js-fixed');
  //     body.style.top = 0;
  //     window.scrollTo( 0 , scrollpos );
  //     state = false;
  //   }
  // }

  // drawerIcon.addEventListener('click',scrollStop);
  // drawerBackground.addEventListener('click',scrollStop);

 });

// 完全に読み込み完了
window.addEventListener('load', () => {
  console.log('Page Loaded.');
  /* 処理内容を記述 */
});

// スムーススクロール 
// need https://github.com/cferdinandi/smooth-scroll
const scroll = new SmoothScroll('a[href*="#"]',{
  ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
  topOnEmptyHash: true, // Scroll to the top of the page for links with href="#"
  speed:200, // Integer. Amount of time in milliseconds it should take to scroll 1000px
  header: '[data-scroll-header]', // Selector for fixed headers (must be a valid CSS selector)
  updateURL: false, // Update the URL on scroll
});

// gsap アニメーション
gsap.registerPlugin(ScrollTrigger);
const wks = gsap.utils.toArray('.js-scroll');
wks.forEach((wk) => {
  gsap.from(wk, {
    scrollTrigger: {
      trigger: wk,
      start: 'top 50%',
      end: 'bottom 0%',
      toggleClass: 'is-scroll',
      // markers: true,
    }
  });
});
const wks2 = gsap.utils.toArray('.js-scroll2');
wks2.forEach((wk) => {
  gsap.from(wk, {
    scrollTrigger: {
      trigger: wk,
      start: 'top 50%',
      end: 'bottom 0%',
      toggleClass: 'is-scroll2',
      // markers: true,
    }
  });
});